export const STORAGE_KEY = "virpluz-lang";

export const LOCALES = [
  { code: "en", label: "EN", htmlLang: "en" },
  { code: "zh-HK", label: "繁", htmlLang: "zh-Hant" },
];

export function isLocale(value) {
  return LOCALES.some((locale) => locale.code === value);
}

export function localeMeta(code) {
  return LOCALES.find((locale) => locale.code === code) || LOCALES[0];
}

export function languageFromPath(pathname = "") {
  const segment = pathname.split("/")[1];
  return isLocale(segment) ? segment : null;
}

export function preferredLanguage() {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    // Storage can be blocked. The URL still decides the language.
  }
  const browser = window.navigator?.language || "";
  if (browser.toLowerCase().startsWith("zh")) return "zh-HK";
  return "en";
}

export function initialLanguage() {
  if (typeof window === "undefined") return "en";
  return languageFromPath(window.location.pathname) || preferredLanguage();
}

export function localizedPath(locale, to = "/") {
  const suffix = !to || to === "/" ? "" : to.startsWith("/") ? to : `/${to}`;
  return `/${locale}${suffix}`;
}

export function swapLocale(pathname, locale) {
  const rest = pathname.replace(/^\/(en|zh-HK)(?=\/|$)/, "") || "/";
  return localizedPath(locale, rest);
}
